<p-card styleClass="rbac-card gridview w-100">
    <p-accordion class="w-full dynamic-search qs-icon" [activeIndex]="0" iconPos="endVal">
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="head-text gap-2 w-full">
                    <span class="font-bold d-flex align-items-center">
                        Youth Search
                        <em class="fa fa-search ml-3" aria-hidden="true"></em>
                    </span>
                </span>
            </ng-template>
            <form class="quick-search-formgroup" [formGroup]="youthQuickSearchForm">
              <div class="row">
                <div class="col-md-12">
                  <p class="infoText">You can search by either JJIS Number or a combination of demographic information. A search by JJIS number cannot include other search criteria. A demographic information search must include partial or full First Name, partial or full Last Name, or Date of Birth. A search including Age or Sex must also include partial or full First Name, or partial or full Last Name.</p>
                </div>
                <div class="col-lg-12 col-xl-9">
                  <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-2 line-right">
                      <label class="referral-form-labels" for="quickSearchJjisNumber">JJIS Number</label>
                      <input type="text" id="quickSearchJjisNumber" formControlName="jjisNumber" placeholder="00000000" autocomplete="off" tabindex="0" (input)="trimSpaces('jjisNumber'); checkFormValues()" maxlength="8" />
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-2">
                      <label class="referral-form-labels" for="quickSearchFirstName">First Name
                        <!--Click Events ToggleToolTip needs to be used. Show Tooltip & hide Tooltip is for mouse hover events. Using Life as a parameter will cause issues in tool tip display-->
                        <i class="fa fa-question-circle ml-1"
                        pTooltip="If this is the only field being used for search, you must enter at least two letters."
                        tooltipPosition="right"
                        aria-hidden="true"
                        tooltipEvent="focus"
                        (click) = "toggleTooltip()"   
                        (mouseover) = "showTooltip()"
                        (mouseleave) = "hideTooltip()"
                        ></i> 
                      </label>
                      <input type="text" id="quickSearchFirstName" formControlName="firstName" placeholder="First Name"
                      autocomplete="off" tabindex="0"
                      (input)="trimSpaces('firstName'); checkFormValues()" />
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-2">
                      <div>
                        <label class="referral-form-labels" for="quickSearchLastName">Last Name</label>
                        <input type="text" id="quickSearchLastName" formControlName="lastName" placeholder="Last Name"
                        autocomplete="off" tabindex="0" (input)="trimSpaces('lastName'); checkFormValues()" />
                      </div>
                      <div class="mt-1 search-alignment">
                        <p-checkbox name="isOwner" inputId="soundexSearch" formControlName="soundexSearch"
                        styleClass="m-2" [binary]="true" (onChange)="checkFormValues()"></p-checkbox>
                        <label for="soundexSearch" aria-labelledby="soundexSearch" class="qs-checkbox">Sounds Like</label>
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-8 col-lg-8 col-xl-4 box-dotted-inside">
                      <div class="d-flex align-items-center qa-dob-border">
                        <div class="form-group">
                            <label class="referral-form-labels" for="quickSearchDob">Date of birth</label>
                            <p-calendar type="date" 
                                      [selectOtherMonths]="true" 
                                      formControlName="dateOfBirth" 
                                      [showIcon]="true" 
                                      [showOnFocus]="false"  
                                      placeholder="mm/dd/yyyy"
                                      inputId="buttondisplay" 
                                      (onSelect)="checkFormValues()" 
                                      (onBlur)="handleManualEntry($event)"
                                      (keydown) = "handleDateInputKeydown($event)"
                                ></p-calendar>
                        </div>
                        <div class="or-text px-2">OR</div>
                        <div class="form-group">
                          <label class="referral-form-labels" for="quickSearchAgeRange">Age</label>
                          <input type="text" id="quickSearchAgeRange" formControlName="age" placeholder="000"
                              tabindex="0" pattern="[0-9]*" autocomplete="off"
                              (keydown)="validateNumericInputKeydown($event, 3)"
                              maxlength="3" />
                      </div>
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-4 col-lg-4 col-xl-2">
                      <label class="referral-form-labels" for="quickSearchSex">Sex</label>
                      <p-dropdown id="quickSearchSex" [options]="sexOptions" optionLabel="name"
                      optionValue="value" formControlName="sex" placeholder="Select Sex" tabindex="0" (onChange)="checkFormValues()" [showClear]="true">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-xl-3 col-md-12 qa-actions">
                  <label class="referral-form-labels invisible">buttons</label>
                  <div class="p-field">
                    <button class="pull-right mb-2 btn btn-primary btncommon" (click)="youthSearchSubmit()"
                    tabindex="0" [disabled]="!formHasValues">
                    <em class="fa fa-search mr-1" aria-hidden="true"></em> Search </button>
                    <button class="pull-right mb-2 mr-2 btn bg-white text-primary btncancel" (click)="youthSearchReset()"
                    tabindex="0">
                    <em class="fa fa-times mr-1" aria-hidden="true"></em> Clear </button>
                  </div>
                </div>
              </div>
                <div class="rbac-card d-none">
                  <div class="row">
                    <div class="col-lg-9">
                      <ul class="quick-search-group list-unstyled d-inline-block w-100 mb-0 field-group">
                          <li class="quick-search-list right-dotted-line pr-lg-4 pr-3 pt-xl-2 pt-lg-0 pt-sm-0 mb-sm-3">
                              <label class="referral-form-labels" for="quickSearchJjisNumber">JJIS Number</label>
                              <input type="text" id="quickSearchJjisNumber" formControlName="jjisNumber" placeholder="00000000"
                                  autocomplete="off" tabindex="0" (input)="trimSpaces('jjisNumber'); checkFormValues()" />
                          </li>
                          <li class="quick-search-list last-name pl-lg-4 pl-sm-3 pt-xl-2 pt-lg-0 pt-sm-0 pr-3 mb-3">
                            <div>
                              <label class="referral-form-labels" for="quickSearchLastName">Last Name</label>
                              <input type="text" id="quickSearchLastName" formControlName="lastName" placeholder="Last Name"
                                  autocomplete="off" tabindex="0" (input)="trimSpaces('lastName'); checkFormValues()" />
                            </div>
                              <div class="mt-1">
                                <p-checkbox name="isOwner" inputId="soundexSearch" formControlName="soundexSearch"
                                styleClass="m-2" [binary]="true" (onChange)="checkFormValues()"></p-checkbox>
                                <label for="soundexSearch" aria-labelledby="soundexSearch" class="qs-checkbox">Sounds Like</label>
                              </div>
                          </li>
                          <li class="quick-search-list first-name pr-md-3 pt-xl-2 pt-lg-0 pt-sm-0 mb-3">
                              <label class="referral-form-labels" for="quickSearchFirstName">First Name</label>
                              <input type="text" id="quickSearchFirstName" formControlName="firstName" placeholder="First Name"
                                  autocomplete="off" tabindex="0" (input)="trimSpaces('firstName'); checkFormValues()" />
                          </li>
                          <li class="quick-search-list dob-box box-dotted mb-sm-0 mb-3">
                              <div class="d-flex align-items-center box-dotted-inside">
                                  <div class="form-group">
                                      <label class="referral-form-labels" for="quickSearchDob">Date of birth</label>
                                      <p-calendar type="date" [selectOtherMonths]="true" formControlName="dateOfBirth" [showIcon]="true" [showOnFocus]="false"  placeholder="mm/dd/yyyy"
                                          inputId="buttondisplay" (onSelect)="checkFormValues()"></p-calendar>
                                  </div>
                                  <div class="or-text px-2">OR</div>
                                  <div class="form-group">
                                      <label class="referral-form-labels" for="quickSearchAgeRange">Age</label>
                                      <input type="text" id="quickSearchAgeRange" formControlName="age" placeholder="000"
                                          tabindex="0" autocomplete="off" (input)="trimSpaces('age'); checkFormValues()" maxlength="3"/>
                                  </div>
                              </div>
                          </li>
                          <li class="quick-search-list sex-list pl-sm-3 pt-sm-2 pt-0 pr-sm-0 pr-3">
                              <label class="referral-form-labels" for="quickSearchSex">Sex:</label>
                              <p-dropdown id="quickSearchSex" [options]="sexOptions" optionLabel="name"
                                  optionValue="value" formControlName="sex" placeholder="Select Sex"
                                  tabindex="0" (onChange)="checkFormValues()" [showClear]="true"></p-dropdown>
                          </li>
                        
                          <li
                              class="quick-search-list ml-md-auto button-lg-only float-sm-none float-right text-right pb-0 actionBtn">
                              <label class="referral-form-labels invisible">buttons</label>
                              <div>
                                  <button type="button" class="btn btn-cancel" (click)="youthSearchReset()"
                                      tabindex="0"><em class="fa fa-times mr-1" aria-hidden="true"></em> Clear</button>
                                  <button type="button" class="btn btn-primary" (click)="youthSearchSubmit()"
                                      tabindex="0" [disabled]="!formHasValues"><em class="fa fa-search mr-1" aria-hidden="true"></em> Search</button>
                              </div>
                          </li>
                      </ul>
                    </div>
                  </div>
                </div>
            </form>
        </p-accordionTab>
    </p-accordion>
    <div *ngIf="tableColumns">
      <app-grid-youth-list [dataSource]="youthSearchResults" [updateGrid]="updateGrid" [columns]="tableColumns"
          [totalCount]="totalCount" (routeTo)="routeTo($event)">
      </app-grid-youth-list>
   </div>
</p-card>
